import fetchServer from "../fetchServer";

export default async function getPackageBookings(
  { limit = 10, skip },
  setLoading,
) {
  let result = {
    return: 0,
    msg: "Something went wrong fetching package bookings!",
    data: null,
  };
  setLoading?.(true);

  try {
    const res = await fetchServer({
      method: "GET",
      url: `/product/v1/nobiPackage/booking?limit=${limit}&skip=${skip}`,
    });
    const apiMessage = res?.data?.message;
    if (res?.data && !res?.data?.error) {
      result = {
        return: 1,
        msg: apiMessage || "Fetched package bookings successfully",
        data: res?.data?.data || [],
      };
    } else {
      result.msg =
        apiMessage ||
        res?.data?.error ||
        "Something went wrong fetching package bookings!";
    }
  } catch (err) {
    // console.error("Network Error!", err);
    result.msg = "Network Error!";
  }
  setLoading?.(false);
  return result;
}
